import React, { useState, useEffect } from "react";
import { Icon, Button, TutorialContainer } from "../../_components";
import { useApp, useModal } from "../../_contexts";
import { helpTopics, parseBBCode } from "../../_helpers";
import { useEventListener } from "../../_hooks";
import ReactTooltip from "react-tooltip";

export function HelpForm({ firstTime, topic }) {
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [filteredTopics, setFilteredTopics] = useState([]);
  const [isEugeneShown, setShowEugene] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const { editMode } = useApp();
  const { closeModal } = useModal();
  ReactTooltip.rebuild();
  const handleHideOnboarding = () => {
    setShowOnboarding(false);
  };

  const handleSearchChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };

  const handleQuickLink = (val) => {
    setSearchVal(val);
  };

  const showEugene = () => {
    setShowEugene(true);
  };

  const hideEugene = () => {
    if (isEugeneShown) {
      setShowEugene(false);
    }
  };

  useEffect(() => {
    hideEugene();
    if (searchVal === "") {
      const topics = helpTopics
        .filter((topic) => {
          if (!editMode && topic.editor) {
            return false;
          }
          return true;
        })
        .map((topic, i) => (
          <HelpTopic topic={topic} key={i} quickLink={handleQuickLink} />
        ));
      setFilteredTopics(topics);
    } else {
      const query = searchVal.toLowerCase();
      if (searchVal === "Eugene") {
        setFilteredTopics([]);
        showEugene();
        return;
      }
      const topics = helpTopics
        .filter((topic) => {
          if (!editMode && topic.editor) {
            return false;
          }
          const name = topic.name.toLowerCase();
          if (name.indexOf(query) > -1) {
            return true;
          }
          if (topic.key.indexOf(query) > -1) {
            return true;
          }
          if (topic.keywords.indexOf(query) > -1) {
            return true;
          }
          return false;
        })
        .map((topic, i) => (
          <HelpTopic topic={topic} key={i} quickLink={handleQuickLink} />
        ));
      setFilteredTopics(topics);
    }
  }, [searchVal]);

  useEffect(() => {
    if (topic && topic.length > 0) {
      setSearchVal(topic);
    }
    ReactTooltip.rebuild();
  }, [topic]);

  const handleKeyClose = (ev) => {
    // console.log("Key up: ", ev);
    if (ev.key && ev.key.toLowerCase() === "escape") {
      closeModal();
      // console.log("Form State: ", { ...formState });
      // if (!formState.isValidating && !formState.isSubmitting) {
      //   if (
      //     formState.dirtyFields &&
      //     Object.keys(formState.dirtyFields).length === 0
      //   ) {
      //     // console.log("dirty fields!");
      //     handleCancel();
      //   }
      // }
    }
  };

  useEventListener("keyup", handleKeyClose);

  return (
    <div className="chronos-help-form">
      <div className="container-fluid no-gutters chronos-help-content">
        <div className="row no-gutters chronos-help-toolbar">
          <div className="col-xs-12 col-md-4">
            <form
              onSubmit={(ev) => ev.preventDefault()}
              className="chronos-list-form"
            >
              <div className="chronos-list-search">
                <input
                  type="text"
                  className="chronos-search-input form-control"
                  placeholder="Search"
                  value={searchVal}
                  onChange={handleSearchChange}
                />
                <Icon icon="fas fa-search fa-fw" />
              </div>
            </form>
          </div>
        </div>
        {showOnboarding && (
          <div className="chronos-help-onboarding">
            <h2 className="chronos-help-onboarding-title">
              What is Chronicles?
            </h2>
            <p>
              World Anvil Chronicles allows you to create an interactive record
              of events and locations within your world. Put simply, you can
              show where and when things happen in your world! You do this by
              interconnecting interactive timelines and interactive maps within
              your Chronicle.
            </p>
            {/* VALUE PROPOSITION GIF - Chronicles */}
            <TutorialContainer
              type="video"
              url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/221b1fa8-6782-461d-a35e-a1d1aad92b5a.webm"
            />
            <p>Search for help topics in the Search bar in the top left.</p>
            <p>
              For more help and guidance, click the titles to expand the topics
              below, read this guide as{" "}
              <a
                href="https://www.worldanvil.com/w/WorldAnvilCodex/a/guide-to-chronicles-article"
                target="_blank"
              >
                an article
              </a>
              , or watch{" "}
              <a
                href="https://www.youtube.com/watch?v=e5-xdYuCEP8"
                target="_blank"
              >
                the video
              </a>
              .
            </p>
            {/* <p>
            This modal contains basic help topics relating to viewing or
            navigating Chronicles. As an 'Editor' of this Chronicle, you can
            access all the topics available. 'Viewers' can only view the topics
            related to navigating the Chronicle in 'Viewer Mode'. This is done
            to ensure that visitors aren't overwhelmed by information that
            doesn't apply to them.
          </p> */}
            <div className="chronos-help-dismiss-onboarding">
              <Button color="primary" onClick={handleHideOnboarding}>
                <Icon icon="far fa-check fa-fw" />
                &nbsp;Hide this Notice
              </Button>
            </div>
          </div>
        )}
        <div className="chronos-help-topics">
          {filteredTopics}
          {isEugeneShown && <Eugene />}
        </div>
      </div>
      <ReactTooltip id="chronos-help-tooltip" effect="solid" />
    </div>
  );
}

function HelpTopic({ topic, quickLink }) {
  const [open, setOpen] = useState(false);
  const tags = topic.keywords
    .split(" ")
    .map((tag) => <QuickTag nav={quickLink} tag={tag} key={tag} />);

  const handleDisplay = () => {
    setOpen(!open);
  };

  const Component = topic.page ? topic.page : <React.Fragment />;

  return (
    <div
      className={
        "chronos-help-topic" + (open ? " chronos-help-topic-open" : "")
      }
    >
      <div className="chronos-help-topic-header" onClick={handleDisplay}>
        <h4 className="chronos-help-topic-title">
          {topic.name}
          <Icon
            icon={"far fa-chevron-right fa-fw" + (open ? " fa-rotate-90" : "")}
          />
        </h4>
      </div>
      {open && (
        <div className="chronos-help-topic-body">
          {/* <div
            className="chronos-help-topic-content"
            dangerouslySetInnerHTML={{ __html: parseBBCode(topic.content) }}
          /> */}
          {/* <div className="chronos-help-topic-content"> */}
          <Component />
          {/* </div> */}
          {topic.codex && (
            <Button color="info" link href={topic.codex}>
              <Icon icon="far fa-eye fa-fw" />
              &nbsp;Visit Codex
            </Button>
          )}
          <div className="chronos-help-topic-tags">
            <h6 className="chronos-help-topic-subheader">Keywords:</h6>
            {tags && tags.length > 0 && <React.Fragment>{tags}</React.Fragment>}
          </div>
        </div>
      )}
    </div>
  );
}

function QuickTag({ tag, nav }) {
  const handleNav = () => {
    if (nav) {
      nav(tag);
    }
  };

  return (
    <span className="chronos-help-topic-tag" onClick={handleNav}>
      {tag}
    </span>
  );
}

function Eugene() {
  const imgs = [
    {
      name: "Eugene Peek",
      url: "https://www.worldanvil.com/uploads/images/18147cdf0ef5414cf4af76dbf12dd9f5.png",
    },
    {
      name: "Eugene Love",
      url: "https://www.worldanvil.com/uploads/images/edd465c813ba1d8f873d28af80cbad32.png",
    },
    {
      name: "Eugene Gesture",
      url: "https://www.worldanvil.com/uploads/images/3f04c08774a6408130742bc06c3bc08f.png",
    },
    {
      name: "Eugene Comfortable",
      url: "https://www.worldanvil.com/uploads/images/376a11524a3150a97ed85faca30ed267.png",
    },
  ];
  const randomImg = Math.floor(Math.random() * imgs.length);
  return (
    <div
      className="chronos-eugenes-office"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        className="chronos-eugene-speech-bubble"
        style={{
          backgroundColor: "white",
          fontSize: "1.3rem",
          fontWeight: 600,
          position: "absolute",
          bottom: "1rem",
          // left: "50%",
          transformOrigin: "50%",
          // transform: "translateX(50%)",
          padding: "0.5rem",
          borderRadius: "4px",
          boxShadow: "0 0 5px 1px #999",
          // zIndex: 10000,
        }}
      >
        Welcome to Chronos!
      </div>
      <img className="chronos-eugene-boss" src={imgs[randomImg].url} />
    </div>
  );
}
